import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent, Button } from '../../../shared/components/ui';
import { dashboardApi } from '../../../shared/services/dashboardApi';
import { BUSINESS_TYPES, findBusinessType } from '../businessTypes';

export function BusinessTypeStep({ onComplete }) {
  const [selected, setSelected] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  async function handleContinue() {
    if (!selected) return;
    setIsSaving(true);
    setError(null);
    try {
      const profile = findBusinessType(selected);
      await dashboardApi.setBusinessType(selected, profile?.defaultVocabularyMode);
      onComplete?.({ businessType: selected, defaultVocabularyMode: profile?.defaultVocabularyMode });
    } catch (err) {
      setError(err?.message || 'Failed to save your business type. Please try again.');
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <Card className="max-w-3xl mx-auto">
      <CardHeader>
        <CardTitle>What kind of work do you do?</CardTitle>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          This helps us organize your line items and tailor cost suggestions. You can change this later in settings.
        </p>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {BUSINESS_TYPES.map((bt) => {
            const isSelected = selected === bt.id;
            return (
              <button
                key={bt.id}
                type="button"
                onClick={() => setSelected(bt.id)}
                className={`text-left p-4 rounded-lg border-2 transition-colors ${
                  isSelected
                    ? 'border-blue-600 bg-blue-50 dark:bg-blue-900/30'
                    : 'border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 bg-white dark:bg-gray-900'
                }`}
              >
                <div className="font-medium text-gray-900 dark:text-gray-100">{bt.label}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">{bt.description}</div>
              </button>
            );
          })}
        </div>

        {error && (
          <div className="mt-4 p-3 rounded-md bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 text-sm">
            {error}
          </div>
        )}

        <div className="flex justify-end mt-6">
          <Button onClick={handleContinue} disabled={!selected || isSaving}>
            {isSaving ? 'Saving…' : 'Continue'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

export default BusinessTypeStep;
